import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Container, Form, Button, Card, Row, Col, Alert, InputGroup, Spinner
} from 'react-bootstrap';
import { FiUser, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { jwtDecode } from 'jwt-decode';


export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        username,
        password,
      }, {
        headers: {
          'Referrer-Policy': 'strict-origin-when-cross-origin'
        }
      });

      localStorage.setItem('token', res.data.token);
      const token = res.data.token;
      localStorage.setItem('token', token);

      const decoded = jwtDecode(token);
      const role = decoded.role;

      if (role === 'superadmin') {
        navigate('/superadmin/dashboard');
      } else if (role === 'officer') {
        navigate('/officer/dashboard');
      }
    } catch (err) {
      setError('Login failed. Check username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Row className="w-100 justify-content-center">
        <Col md={6} lg={4}>
          <Card className="p-4 shadow-lg rounded-4">
            <Card.Body>
            <img
          src={"/shaff_logo.png"}
          alt="Shaff" class="mb-3"
          style={{ width: "100%", display: "flex", justifyContent: "center", objectFit: "cover" }}
        />
              {/* <h3 className="text-center mb-4">Shaff HRIS Login</h3> */}

              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleLogin}>
                <Form.Group className="mb-3">
                  <Form.Label><FiUser /> Username</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label><FiLock /> Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPass ? 'text' : 'password'}
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <InputGroup.Text onClick={() => setShowPass(!showPass)} style={{ cursor: 'pointer' }}>
                      {showPass ? <FiEyeOff /> : <FiEye />}
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                      {' '}Logging in...
                    </>
                  ) : 'Login'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
